import { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Link from '@/lib/siteLink';
import { Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { label: 'Writing', to: '/vikas/blog' },
  { label: 'Book', to: '/vikas/book' },
  { label: 'Speaking', to: '/vikas/speaking' },
  { label: 'For founders', to: '/vikas/work-with-me' },
  { label: 'Contact', to: '/vikas/contact' },
];

export default function VikasNav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-gray-100" data-testid="vikas-navbar">
      <div className="max-w-3xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/vikas" className="font-serif text-xl font-bold text-black tracking-tight" data-testid="vikas-logo-link">
          Vikasifications
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className={`text-sm font-medium transition-colors ${isActive(l.to) ? 'text-black' : 'text-black hover:opacity-70'}`}>
              {l.label}
            </Link>
          ))}
        </div>

        <button className="md:hidden p-2 text-black" onClick={() => setMobileOpen(!mobileOpen)} data-testid="vikas-mobile-menu">
          {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden border-t border-gray-100 bg-white px-6 py-4 space-y-2">
          {NAV_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="block py-2 text-sm text-black hover:opacity-70">{l.label}</Link>
          ))}
        </div>
      )}
    </nav>
  );
}
